export default __webpack_public_path__ + "static/media/outdoor.a697deb0.webp";